'use strict';

var shape$1 = require('../../../../_virtual/shape.js_commonjs-exports.js');

Object.defineProperty(shape$1.__exports, "__esModule", {
  value: true
});
shape$1.__exports.default = void 0;
var shape = {
  borderRadius: 4
};
var _default = shape;
shape$1.__exports.default = _default;
